import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";

const loadGoogleMaps = () => {
  if (document.getElementById("google-maps-script")) return;

  const script = document.createElement("script");
  script.id = "google-maps-script";
  script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places`;
  script.async = true;
  script.defer = true;

  document.body.appendChild(script);
};

loadGoogleMaps();

const originalWarn = console.warn;

console.warn = function (...args) {
  const message = args[0];

  if (
    typeof message === "string" &&
    (message.includes("DirectionsRenderer is deprecated") ||
      message.includes("DirectionsService is deprecated"))
  ) {
    return;
  }

  originalWarn.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
